import { RootState } from "src/stores/redux/store";

// Root slice
const getFlowDesigner = (state: RootState) => state.flowDesigner;
const getFlowDesignerUI = (state: RootState) => state.flowDesigner.ui;

// Top-level fields
export const getAppFQN = (state: RootState) => getFlowDesigner(state).appFQN;
export const getAppModel = (state: RootState) => getFlowDesigner(state).appModel;
export const getAppStatus = (state: RootState) => getFlowDesigner(state).appStatus;
export const getCurrentFlowId = (state: RootState) => getFlowDesigner(state).currentFlowId;
export const getNodes = (state: RootState) => getFlowDesigner(state).nodes;
export const getEdges = (state: RootState) => getFlowDesigner(state).edges;
export const getSelectedNode = (state: RootState) => getFlowDesigner(state).selectedNode;
export const getNamespace = (state: RootState) => getFlowDesigner(state).namespace;
export const getIsFetchingNodes = (state: RootState) => getFlowDesigner(state).isFetchingNodes;
export const getIsEmpty = (state: RootState) => getFlowDesigner(state).isEmpty;
export const getIsAutomatedGroup = (state: RootState) => getFlowDesigner(state).isAutomatedGroup;
export const getGroup = (state: RootState) => getFlowDesigner(state).group;
export const getExceptionsCount = (state: RootState) => getFlowDesigner(state).exceptionsCount;
export const getClipboard = (state: RootState) => getFlowDesigner(state).clipboard;
export const getNeedsRefresh = (state: RootState) => getFlowDesigner(state).needsRefresh;
export const getStreamPreviewData = (state: RootState) => getFlowDesigner(state).streamPreviewData;
export const getLoadLocalErrors = (state: RootState) => getFlowDesigner(state).loadLocalErrors;

// UI fields
export const getCurrentLayout = (state: RootState) => getFlowDesignerUI(state).currentLayout;
export const getCurrentPlacementAlgorithm = (state: RootState) => getFlowDesignerUI(state).currentPlacementAlgorithm;
export const getIsSidebarFullWidth = (state: RootState) => getFlowDesignerUI(state).isSidebarFullWidth;
export const getIsRightSidebarOpen = (state: RootState) => getFlowDesignerUI(state).isRightSidebarOpen;
export const getIsExceptionsSidebarOpen = (state: RootState) => getFlowDesignerUI(state).isExceptionsSidebarOpen;
export const getIsMetadataBrowserOpen = (state: RootState) => getFlowDesignerUI(state).isMetadataBrowserOpen;
export const getIsAppErrorsSidebarOpen = (state: RootState) => getFlowDesignerUI(state).showAppErrorsSidebar;
export const getIsValidationErrorsSidebarOpen = (state: RootState) =>
    getFlowDesignerUI(state).showValidationErrorsSidebar;
export const getIsAppSettingsSidebarOpen = (state: RootState) => getFlowDesignerUI(state).showAppSettingsSidebar;
export const getAppSettingsDeployment = (state: RootState) => getFlowDesignerUI(state).appSettingsDeployment;
export const getShowMinimap = (state: RootState) => getFlowDesignerUI(state).showMinimap;
export const getShowProgressView = (state: RootState) => getFlowDesignerUI(state).showProgressView;
export const getFormType = (state: RootState) => getFlowDesignerUI(state).formType;
export const getIsTableProgressModalOpen = (state: RootState) => getFlowDesignerUI(state).isTableProgressModalOpen;
export const getIsStreamPreviewVisible = (state: RootState) => getFlowDesignerUI(state).isStreamPreviewVisible;
export const getIsStreamGraphPreviewVisible = (state: RootState) =>
    getFlowDesignerUI(state).isStreamGraphPreviewVisible;
export const getIsStreamPreviewExpanded = (state: RootState) => getFlowDesignerUI(state).isStreamPreviewExpanded;
export const getIsDiscoverPIISidebarOpen = (state: RootState) => getFlowDesignerUI(state).isDiscoverPIISidebarOpen;
export const getDiscoverPIIDefaultJob = (state: RootState) => getFlowDesignerUI(state).discoverPIIDefaultJob;
export const getIsSentinelLiveMonitorSidebarOpen = (state: RootState) =>
    getFlowDesignerUI(state).isSentinelLiveMonitorSidebarOpen;
export const getSentinelLiveMonitorDefaultSentinel = (state: RootState) =>
    getFlowDesignerUI(state).sentinelLiveMonitorDefaultSentinel;
export const getIsConversationalMode = (state: RootState) => getFlowDesignerUI(state).isConversationalMode;
